<script>
    import Button from "./Button.svelte";
    import IconLink from "./IconLink.svelte";
    let forceRerender = 0;
    if (!globalThis.activeMods) {
        globalThis.activeMods = [];
    }
</script>

<div class="flex">
    <aside class="">
        <div class="flex flex-direction-column gap-15 pad-20">
            <div class="flex flex-direction-column gap-15">
                <div class="flex align-items-center gap-20">
                    <Button
                        on:click={() => window.goBack()}
                        type="button"
                        text="🠔 Back"
                        class="sm"
                    />
                    <h1 class="aside-title">{globalThis.i18n("Mods")}</h1>
                </div>
            </div>
            <div>Modding works in both singleplayer and multiplayer!</div>
            <div>
                Join the #modding channel in the Spellmasons Discord to keep up
                with the latest news on modding!
            </div>
            <IconLink
                src="ui/discord_logo.png"
                alt="Spellmasons Discord https://discord.gg/q6sUCreHeJ"
                width="24px"
                href="https://discord.gg/q6sUCreHeJ"
                class="button-wrapper-bg-2"
                text="Spellmasons Discord"
            />
            <IconLink
                src="ui/externalLink.svg"
                href="https://youtube.com/playlist?list=PLrNoNMIiNc_E7L-n4GGboHXQJq-cP2Cs1"
                text="Make your Own Mod Youtube Series"
            />
            <IconLink
                src="ui/externalLink.svg"
                href="https://github.com/jdoleary/Spellmasons"
                text="Engine Source Code"
            />
            <IconLink
                src="ui/externalLink.svg"
                href="https://github.com/jdoleary/spellmasons-mods"
                text="Mod Library Source Code"
            />
        </div>
    </aside>
    <main>
        {#if globalThis.mods}
            {#key forceRerender}
                <table class="modlist">
                    <tbody>
                        {#each globalThis.mods as { modName, author, description, screenshot, spells, units, pickups }}
                            <tr class="mod-box">
                                <td class="mod-screenshot">
                                    {#if screenshot !== undefined}
                                        <img src={screenshot} alt="mod" />
                                    {/if}
                                </td>
                                <td style="white-space:nowrap;">
                                    <h3 class="mod-name">
                                        {modName}
                                    </h3>
                                    <div>
                                        by: {author}
                                    </div>
                                </td>
                                <td class="mod-description">
                                    <!-- <div>{description}</div> -->
                                    <div>
                                        {spells && spells.length
                                            ? "Spells: " +
                                              spells
                                                  .map((s) => s.card.id)
                                                  .join(", ")
                                            : ""}
                                    </div>
                                    <div>
                                        {units && units.length
                                            ? "Units: " +
                                              units.map((u) => u.id).join(", ")
                                            : ""}
                                    </div>
                                    <div>
                                        {pickups && pickups.length
                                            ? "Pickups: " +
                                              pickups
                                                  .map((p) => p.name)
                                                  .join(", ")
                                            : ""}
                                    </div>
                                </td>
                                <td class="mod-button">
                                    <Button
                                        text={globalThis.activeMods.indexOf(
                                            modName
                                        ) === -1
                                            ? globalThis.i18n("Enable")
                                            : globalThis.i18n("Disable")}
                                        class={globalThis.activeMods.indexOf(
                                            modName
                                        ) === -1
                                            ? "appear-disabled"
                                            : ""}
                                        style="text-align:center;"
                                        on:click={() => {
                                            if (
                                                globalThis.activeMods.indexOf(
                                                    modName
                                                ) === -1
                                            ) {
                                                globalThis.activeMods.push(
                                                    modName
                                                );
                                            } else {
                                                globalThis.activeMods =
                                                    globalThis.activeMods.filter(
                                                        (m) => m !== modName
                                                    );
                                            }
                                            globalThis.saveActiveMods(
                                                globalThis.activeMods
                                            );

                                            forceRerender+=1;
                                        }}
                                    />
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            {/key}
        {:else}
            <div>
                <div class="margin-bottom-15">
                    No mods found. Try verifying the integrity of Steam game
                    files.
                </div>
                <img
                    src="ui/verifyIntegrity.gif"
                    alt="shows how to verify the integrity of steam game files"
                />
            </div>
        {/if}
    </main>
</div>

<style>
    main {
        /* Wider to allow for longer mod descriptions */
        max-width: 1200px;
        width: 100%;
        margin: 0 80px;
    }
    aside {
        max-width: 260px;
    }
    table {
        border-collapse: separate;
        /* To allow the tr to have a consistent background color without gaps */
        border-spacing: 0;
        width: 100%;
    }
    tr:nth-child(odd) {
        background-color: #3b3b3b;
    }
    tr:hover {
        background-color: #636363;
    }

    td {
        padding: 8px;
        vertical-align: top;
        text-align: left;
    }

    .mod-button {
        vertical-align: middle;
    }
    .mod-description {
        padding-top: 12px;
    }
    .mod-name {
        margin: 0;
    }
    .mod-box {
        border: 1px solid white;
    }
    .mod-box .mod-screenshot {
        width: 100px;
        height: 80px;
    }
    .mod-box img {
        height: 80px;
        width: 100%;
        object-fit: contain;
    }
    div {
        color: white;
    }
</style>
